<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración Roles de Usuarios</li>
</ol>

<h1 class="page-header"><i class="fas fa-tachometer-alt"></i> Administración Roles de Usuarios</h1>

<panel [noButton]="true">
    <div class="row">
        <div class="d-flex justify-content-end pr-5">
            <button class="btn btn-primary btn-sm" (click)="open(modalRoleForm)">Nuevo Rol</button>
        </div>
    </div>
    <div class="row">
        <div class="table-responsive">
        <table class="table table-sm table-striped table-hover my-5">
            <thead>
                <tr>
                    <th class="text-center">N°</th>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th class="text-center">Habilitado</th>
                    <th class="text-center">Orden</th>
                    <th class="text-center"><i class="fas fa-cogs"></i></th>
                </tr>
            </thead>
            <tbody>
                @for(role of roles; track $index){
                <tr>
                    <td class="text-center">{{ $index + 1 }}</td>
                    <td>{{ role.name }}</td>
                    <td>{{ role.description }}</td>
                    <td>
                        <div class="form-check form-switch d-flex justify-content-center">
                            <input class="form-check-input" type="checkbox" id="checkbox1" [checked]="role.enabled" (change)="enabledRole(role)"/>
                        </div>
                    </td>
                    <td class="text-center" style="white-space: nowrap;">
                        <button class="btn btn-xs btn-secondary mx-1" (click)="moveUp(role)" [disabled]="$index === 0"
                            ngbTooltip="Subir"><i class="fas fa-angle-up"></i></button>
                        <button class="btn btn-xs btn-secondary mx-1" (click)="moveDown(role)" [disabled]="$index === roles.length - 1"
                            ngbTooltip="Bajar"><i class="fas fa-angle-down"></i></button>
                    </td>
                    <td class="text-center">
                        <button class="btn btn-xs btn-primary mx-2" (click)="open(modalRoleForm, role)"
                            ngbTooltip="Revisar Evaluación"><i class="fas fa-eye"></i></button>
                        
                    </td>



                </tr>
                }
                @empty{
                <tr>
                    <td colspan="6" class="text-center">No hay registros</td>
                </tr>

                }
            </tbody>
        </table>
        </div>
    </div>
</panel>


<ng-template #modalRoleForm let-c="close" let-d="dismiss">

    <div class="modal-header">
        <span class="fs-3 fw-700">Datos Usuario</span>
    </div>
    <div class="modal-body" [formGroup]="newRoleForm">
        <div class="row mb-3">

            <div class="col-md-6">
                <label class="form-label col-form-label col-md-3">Nombre</label>
                <input type="text" class="form-control" placeholder="Nombre" formControlName="name" />
            </div>
            <div class="col-md-6">
                <label class="form-label col-form-label col-md-3">Descripción</label>
                <input type="text" class="form-control" placeholder="Descripción" formControlName="description" />
            </div>
        </div>

    </div>

    <div class="modal-footer">
        <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
        <button class="btn btn-primary" (click)="d('Cross click'); saveRole()">Guardar</button>
    </div>
</ng-template>